import { TireHotelRehomeStatus } from '@navio/nsdk';

export const OPEN_REHOME_STATUSES: TireHotelRehomeStatus[] = [
  TireHotelRehomeStatus.DRAFT,
  TireHotelRehomeStatus.PENDING_BUYER
];
